
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { CollectionType, CollectionPayloadType } from "@/common/types/collection";

export async function collectionList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/collection/list${queryString}`
    );
}

export async function collectionGet(
    collection_id: string
) {
    return await clientAxios.get(
        `admin/collection/${collection_id}/show`
    );
}

export async function collectionAdd(
    payload: CollectionPayloadType
) {
    return await clientAxios.post(
        `admin/collection/create`,
        payload
    );
}

export async function collectionCopy(
    collection_id: string
) {
    return await clientAxios.post(
        `admin/collection/${collection_id}/copy`,
        null
    );
}

export async function collectionPatch(
    collection_id: string,
    payload: Partial<CollectionType>
) {
    return await clientAxios.patch(
        `admin/collection/${collection_id}/patch`,
        { payload }
    );
}

export async function collectionDel(
    collection_id: string,
) {
    return await clientAxios.del(
        `admin/collection/${collection_id}/delete`,
    );
}
